export default "__VITE_ASSET__BfprwjeO__"